module.exports = __webpack_public_path__ + "img/pin-default-face.0517b3c2.png";